import { ICreateAndUpdateFinancialGroup } from "../../../types/financialGroup";
import customAxios from "../../customAxios";
import { UPDATE_PRICE_FACTOR_4_ADMIN } from "../../routes";

const updateFactorPrice = async (_id: string, price: number) => {
  try {
    return (await customAxios.put(UPDATE_PRICE_FACTOR_4_ADMIN + `/${_id}`, {price})).data;
  } catch (error: unknown) {
    console.error({ UPDATE_PRICE_FACTOR_4_ADMIN: error });
    return false;
  }
};

export default updateFactorPrice;
